import { useElementMeasures } from '@hooks/useElementMeasures';
import { cn } from '@utils/cn';
import { SvgConsumer } from '@components/icons/svgConsumer';
import { forwardRef } from 'react';
import type { DrawerProps } from './types';
import {
  DrawerRoot,
  DrawerHeader,
  DrawerTitle,
  DrawerClose,
  DrawerPortal,
  DrawerOverlay,
  DrawerContent,
} from '..';

export const Drawer = forwardRef<HTMLDivElement, DrawerProps>(
  ({ open, setOpen, title, children, className }, ref) => {
    const headerHeight = useElementMeasures('header').height;

    return (
      <DrawerRoot open={open} onOpenChange={setOpen} direction="right">
        <DrawerPortal>
          <DrawerOverlay />
          <DrawerContent
            ref={ref}
            className={cn(
              'fixed bottom-auto left-auto right-0 top-0 h-auto w-full max-w-[800px] overflow-hidden rounded-none border-b-0 border-l border-r-0 border-t-0 shadow-card transition-transform duration-150',
              className,
            )}
            style={{
              top: headerHeight,
              maxHeight: `calc(100vh - ${headerHeight}px)`,
            }}>
            <DrawerHeader className="sticky top-0 z-10 flex h-10 flex-row items-center justify-between border-b bg-white px-2 py-0">
              <DrawerTitle className="m-0 min-w-0 flex-1 text-base font-semibold text-neutral-800">
                {title}
              </DrawerTitle>
              <DrawerClose asChild>
                <button
                  className="p-1 text-xs text-neutral-300 hover:text-neutral-800"
                  type="button">
                  <SvgConsumer id="close" />
                </button>
              </DrawerClose>
            </DrawerHeader>
            {children}
          </DrawerContent>
        </DrawerPortal>
      </DrawerRoot>
    );
  },
);
